import api from "./axios";
import { apiPaths } from "./paths";
import type { FeatureFlag, FeatureFlagRule, ApiMessage } from "@/types";

export const getFeatureFlags = (projectId?: string) =>
  api
    .get<FeatureFlag[]>(apiPaths.featureFlags.list, {
      params: projectId ? { projectId } : {},
    })
    .then((r) => r.data);

export const getFeatureFlag = (id: string) =>
  api.get<FeatureFlag>(apiPaths.featureFlags.one(id)).then((r) => r.data);

export const createFeatureFlag = (
  data: Partial<FeatureFlag> & { projectId: string },
) =>
  api.post<FeatureFlag>(apiPaths.featureFlags.list, data).then((r) => r.data);

export const updateFeatureFlag = (id: string, data: Partial<FeatureFlag>) =>
  api
    .patch<FeatureFlag>(apiPaths.featureFlags.one(id), data)
    .then((r) => r.data);

export const toggleFeatureFlag = (id: string) =>
  api.patch<FeatureFlag>(apiPaths.featureFlags.toggle(id)).then((r) => r.data);

export const deleteFeatureFlag = (id: string) =>
  api.delete<ApiMessage>(apiPaths.featureFlags.one(id)).then((r) => r.data);

export const getRules = (flagId: string) =>
  api
    .get<FeatureFlagRule[]>(apiPaths.featureFlags.rules(flagId))
    .then((r) => r.data);

export const addRule = (
  flagId: string,
  data: {
    matchPropertyId: string;
    matchPropertyValues: string[];
    rolloutPercentage?: number;
  },
) =>
  api
    .post<FeatureFlagRule>(apiPaths.featureFlags.rules(flagId), data)
    .then((r) => r.data);

export const updateRule = (
  flagId: string,
  ruleId: string,
  data: Partial<FeatureFlagRule>,
) =>
  api
    .patch<FeatureFlagRule>(apiPaths.featureFlags.rule(flagId, ruleId), data)
    .then((r) => r.data);

export const deleteRule = (flagId: string, ruleId: string) =>
  api
    .delete<ApiMessage>(apiPaths.featureFlags.rule(flagId, ruleId))
    .then((r) => r.data);
